module.exports = __webpack_public_path__ + "img/s8sLogo4.76c0dd0b.png";